import create from 'zustand';
import { DEFAULT_FILTER, DEFAULT_PAGINATION, MeterListFilter, MeterListPagination } from './const';

const INITIAL_STATE = { filter: DEFAULT_FILTER, pagination: DEFAULT_PAGINATION } as const;

export interface MeterListStore {
  filter: MeterListFilter;
  pagination: MeterListPagination;
  updateFilter: (payload: Partial<MeterListFilter>) => void;
  updatePagination: (payload: Partial<MeterListPagination>) => void;
  reset: () => void;
}

export const useStore = create<MeterListStore>(set => ({
  filter: DEFAULT_FILTER,
  pagination: DEFAULT_PAGINATION,
  updateFilter: (payload: Partial<MeterListFilter>) =>
    set(prevState => ({
      filter: { ...prevState.filter, ...payload },
    })),
  updatePagination: (payload: Partial<MeterListPagination>) =>
    set(prevState => ({
      pagination: { ...prevState.pagination, ...payload },
    })),
  reset: () => set(INITIAL_STATE),
}));
